var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4182_197875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 1.25C10.5552 1.25 11.0669 1.54297 11.3482 2.02344L19.7857 16.3984C20.0708 16.8828 20.0708 17.4805 19.7935 17.9648C19.5161 18.4492 18.9966 18.75 18.438 18.75H1.56301C1.00442 18.75 0.484886 18.4492 0.207543 17.9648C-0.0698012 17.4805 -0.0658949 16.8789 0.215355 16.3984L8.65285 2.02344C8.9341 1.54297 9.44582 1.25 10.0005 1.25ZM10.0005 6.25C9.48098 6.25 9.06301 6.66797 9.06301 7.1875V11.5625C9.06301 12.082 9.48098 12.5 10.0005 12.5C10.52 12.5 10.938 12.082 10.938 11.5625V7.1875C10.938 6.66797 10.52 6.25 10.0005 6.25ZM11.2505 15C11.2505 14.6685 11.1188 14.3505 10.8844 14.1161C10.65 13.8817 10.332 13.75 10.0005 13.75C9.66899 13.75 9.35105 13.8817 9.11663 14.1161C8.88221 14.3505 8.75051 14.6685 8.75051 15C8.75051 15.3315 8.88221 15.6495 9.11663 15.8839C9.35105 16.1183 9.66899 16.25 10.0005 16.25C10.332 16.25 10.65 16.1183 10.8844 15.8839C11.1188 15.6495 11.2505 15.3315 11.2505 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4182_197875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5299d1543231fcd6a50325c6f8d5eb3a.svg";
export { ForwardRef as ReactComponent };